/* Hearsay theme scripts: bag drawer, bundle picker, gallery, small UI helpers. No dependencies. */
(function () {
  'use strict';
  var H = window.Hearsay || {};
  var S = H.strings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || H.moneyFormat || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      var n = (number / 100).toFixed(precision).split('.');
      var whole = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (n[1] ? decimal + n[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2800);
  }

  /* ---------- Delivery estimate: fills every [data-eta] ---------- */
  function fillEta() {
    var d = H.delivery || { min: 4, max: 10 };
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + Number(d.min));
    b.setDate(b.getDate() + Number(d.max));
    var locale = document.documentElement.lang || 'en-US';
    var fmt = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
    var text = a.getMonth() === b.getMonth()
      ? fmt.format(a) + '–' + b.getDate()
      : fmt.format(a) + ' – ' + fmt.format(b);
    $$('[data-eta]').forEach(function (el) { el.textContent = text; });
  }

  /* ---------- Toggles (mobile menu, search) ---------- */
  function initToggles() {
    $$('[data-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-toggle'));
        if (!target) return;
        var open = target.hidden;
        $$('[data-toggle]').forEach(function (other) {
          var t = document.getElementById(other.getAttribute('data-toggle'));
          if (t && t !== target) { t.hidden = true; other.setAttribute('aria-expanded', 'false'); }
        });
        target.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { var input = target.querySelector('input[type="search"]'); if (input) input.focus(); }
      });
    });
  }

  /* ---------- Bag drawer ---------- */
  var drawer, scrim, lastFocus;
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 250);
    });
  }
  function renderCart(cart) {
    var box = $('#CartItems'), foot = $('#CartFoot');
    if (!box) return;
    setCount(cart.item_count);
    if (!cart.item_count) {
      foot.hidden = true;
      box.innerHTML = '<div class="empty"><h3>' + escapeHtml(S.emptyTitle) + '</h3><p>' + escapeHtml(S.emptyText) +
        '</p><a class="btn btn-berry" style="margin-top:18px" href="' + escapeHtml(H.emptyCta) + '">' + escapeHtml(S.shopCta) + '</a></div>';
      return;
    }
    foot.hidden = false;
    $('#CartTotal').textContent = formatMoney(cart.total_price);
    box.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var img = item.image
        ? '<img src="' + escapeHtml(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" width="72" height="72" loading="lazy">'
        : '';
      var variant = item.product_has_only_default_variant ? '' : '<small>' + escapeHtml(item.variant_title) + '</small>';
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="line">' +
        '<a class="pic" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div><a class="title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant +
          '<div class="qty"><button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="−">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button></div></div>' +
        '<div class="amt">' + formatMoney(item.final_line_price) + was +
          '<button class="rm" type="button" data-line="' + line + '" data-qty="0">' + escapeHtml(S.remove) + '</button></div>' +
      '</div>';
    }).join('');
  }
  function fetchCart() {
    return fetch(H.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-on');
    scrim.classList.add('is-on');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var c = drawer.querySelector('[data-cart-close]'); if (c) c.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-on')) return;
    drawer.classList.remove('is-on');
    scrim.classList.remove('is-on');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function changeLine(line, qty) {
    drawer.setAttribute('aria-busy', 'true');
    fetch(H.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { toast(S.error); })
      .finally(function () { drawer.removeAttribute('aria-busy'); });
  }
  function initDrawer() {
    drawer = $('#CartDrawer');
    scrim = $('#CartScrim');
    if (!drawer) return;
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (H.cartType !== 'drawer' || document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        fetchCart().then(openDrawer);
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeDrawer();
      var q = e.target.closest('#CartItems [data-line]');
      if (q) changeLine(Number(q.getAttribute('data-line')), Number(q.getAttribute('data-qty')));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Bundle picker + add to bag ---------- */
  function selectedInput(wrap) { return wrap.querySelector('[data-bundles] input:checked'); }

  function updateBundle(wrap) {
    var input = selectedInput(wrap);
    if (!input) return;
    var price = Number(input.dataset.price);
    var compare = Number(input.dataset.compare);
    var jars = Number(input.dataset.jars) || 1;
    var available = input.dataset.available === 'true';
    var addBtn = wrap.querySelector('[data-add-button]');

    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? S.addToBag + ' · ' + formatMoney(price) : S.soldOut;
    }

    var now = wrap.querySelector('[data-price-now]');
    if (now) now.textContent = formatMoney(price);
    var math = wrap.querySelector('[data-price-math]');
    var save = wrap.querySelector('[data-price-save]');
    var single = Number(wrap.dataset.singlePrice);
    if (math) {
      if (compare > price) {
        math.innerHTML = jars + ' × ' + formatMoney(single) + ' = <s>' + formatMoney(compare) + '</s>';
        math.hidden = false;
      } else { math.hidden = true; }
    }
    if (save) {
      if (compare > price) {
        save.textContent = S.save + ' ' + formatMoney(compare - price);
        save.hidden = false;
      } else { save.hidden = true; }
    }

    var sticky = $('[data-sticky-atc]');
    if (sticky && wrap.closest('[data-product-page]')) {
      var lbl = sticky.querySelector('[data-sticky-label]');
      var title = $('[data-product-page] h1');
      if (lbl) lbl.textContent = (title ? title.textContent.trim() + ' · ' : '') + input.dataset.title;
      var sp = sticky.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = formatMoney(price);
    }

    if (wrap.closest('[data-product-page]') && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initProductForms() {
    $$('[data-product-form-wrap]').forEach(function (wrap) {
      var form = wrap.querySelector('form[data-product-form]');
      if (!form) return;
      var single = wrap.getAttribute('data-single-price');
      if (!single) {
        var first = wrap.querySelector('[data-bundles] input');
        if (first) wrap.dataset.singlePrice = first.dataset.price;
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-bundles] input')) updateBundle(wrap);
      });
      updateBundle(wrap);

      form.addEventListener('submit', function (e) {
        if (H.cartType !== 'drawer') return;
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]');
        var err = wrap.querySelector('[data-form-error]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = S.adding; }
        if (err) err.hidden = true;
        fetch(H.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || S.error);
            return fetchCart().then(openDrawer);
          })
          .catch(function (error) {
            if (err) { err.textContent = error.message || S.error; err.hidden = false; }
            else toast(error.message || S.error);
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            updateBundle(wrap);
          });
      });
    });
  }

  /* ---------- Sticky add-to-bag bar (mobile, product page) ---------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]');
    var mainBtn = $('[data-product-page] [data-add-button]');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-sticky-add]');
    new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', hidden);
      bar.setAttribute('aria-hidden', String(!hidden));
      btn.tabIndex = hidden ? 0 : -1;
    }).observe(mainBtn);
    btn.addEventListener('click', function () {
      var form = mainBtn.closest('form');
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var slides = $$('.gallery__slide', g);
      if (slides.length < 2) return;
      var cap = $('[data-gallery-caption]', g);
      var count = $('[data-gallery-count]', g);
      var thumbs = $$('[data-go]', g);
      var current = 0;
      function go(n) {
        current = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', Number(t.dataset.go) === current ? 'true' : 'false'); });
        if (cap) { var c = slides[current].dataset.caption; cap.textContent = c; cap.hidden = !c; }
        if (count) count.textContent = (current + 1) + ' / ' + slides.length;
        slides.forEach(function (s, i) { var v = s.querySelector('video'); if (v) { if (i === current) v.play().catch(function () {}); else v.pause(); } });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.go)); }); });
      var main = $('.gallery__main', g), x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---------- Review filter chips ---------- */
  function initChips() {
    $$('[data-chips]').forEach(function (group) {
      var section = group.closest('section');
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-chip]');
        if (!chip) return;
        $$('[data-chip]', group).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        var tag = chip.dataset.chip;
        $$('.review', section).forEach(function (r) {
          var tags = (r.dataset.tags || '').split(/\s+/);
          r.hidden = tag !== 'all' && tags.indexOf(tag) === -1;
        });
      });
    });
  }

  /* ---------- Misc ---------- */
  function initMisc() {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
    var rec = $('[data-toggle-recover]');
    if (rec) rec.addEventListener('click', function (e) {
      e.preventDefault();
      var box = $('#RecoverBox');
      box.hidden = !box.hidden;
      if (!box.hidden) box.querySelector('input').focus();
    });
    if (window.location.hash === '#RecoverBox' || window.location.hash === '#recover' || $('[data-recover-open]')) { var b = $('#RecoverBox'); if (b) b.hidden = false; }
  }


  /* ---------- Copy buttons (email) ---------- */
  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy]');
      if (!btn) return;
      var text = btn.getAttribute('data-copy');
      var label = btn.textContent;
      var done = function () {
        btn.textContent = btn.getAttribute('data-copied') || 'Copied';
        setTimeout(function () { btn.textContent = label; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text); done(); });
      } else { fallbackCopy(text); done(); }
    });
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
  }

  /* ---------- Tracking number lookup ---------- */
  var CARRIERS = {
    usps: function (n) { return 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + n; },
    ups: function (n) { return 'https://www.ups.com/track?loc=en_US&tracknum=' + n; },
    fedex: function (n) { return 'https://www.fedex.com/fedextrack/?trknbr=' + n; },
    dhl: function (n) { return 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=' + n; },
    any: function (n) { return 'https://parcelsapp.com/en/tracking/' + n; }
  };
  function detectCarrier(n) {
    if (/^1Z[0-9A-Z]{16}$/.test(n)) return 'ups';
    if (/^(94|93|92|95|420\d{5,9}9[2-5])\d{18,30}$/.test(n) || /^[A-Z]{2}\d{9}US$/.test(n)) return 'usps';
    if (/^(\d{12}|\d{15}|\d{20}|\d{22})$/.test(n)) return 'fedex';
    if (/^(\d{10}|JD\d{18}|JJD\d{16,20})$/.test(n)) return 'dhl';
    return 'any';
  }
  function initTrack() {
    $$('[data-track-form]').forEach(function (form) {
      var msg = form.querySelector('[data-track-msg]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var raw = (form.elements.tracking.value || '').toUpperCase().replace(/[\s-]/g, '');
        msg.classList.remove('form-msg--err');
        if (!raw) {
          msg.textContent = form.getAttribute('data-msg-empty');
          msg.classList.add('form-msg--err');
          form.elements.tracking.focus();
          return;
        }
        var choice = form.elements.carrier.value;
        var carrier = choice === 'auto' ? detectCarrier(raw) : choice;
        var url = CARRIERS[carrier](encodeURIComponent(raw));
        var win = window.open(url, '_blank');
        if (win) { try { win.opener = null; } catch (err) {} msg.textContent = form.getAttribute('data-msg-opened'); }
        else { window.location.href = url; }
      });
    });
  }

  function init() {
    fillEta();
    initToggles();
    initDrawer();
    initProductForms();
    initSticky();
    initGallery();
    initChips();
    initMisc();
    initCopy();
    initTrack();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when sections reload */
  document.addEventListener('shopify:section:load', function () {
    fillEta(); initProductForms(); initGallery(); initChips();
  });
})();
